// extracted by mini-css-extract-plugin
module.exports = {"container":"Submitted_container__v0dBD","title":"Submitted_title__2zw8-","description":"Submitted_description__c7cto"};